import { authReducer } from './auth/auth.reducer';
import { newsReducer } from './news/news.reducer';
import { companyContactsReducer } from './company-contacts/company-contacts.reducer';
import { documentationReducer } from './documentation/documentation.reducer';

const storeReducers = {
  auth: authReducer,
  news: newsReducer,
  companyContacts: companyContactsReducer,
  documentation: documentationReducer,
};

export default storeReducers;
